/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  }
  
  // /**
  //  * @param {string} str
  //  * @returns {Boolean}
  //  */
  // export function validUsername (str) {
  //   const valid_map = ['admin', 'editor']
  //   return valid_map.indexOf(str.trim()) >= 0
  // }
  
  /**
   * @param {string} url
   * @returns {Boolean}
   */
  export function validURL (url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
  }
  
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  export function validLowerCase (str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  }
  
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  export function validUpperCase (str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
  }
  
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  export function validAlphabets (str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  }
  
  // /**
  //  * @param {string} email
  //  * @returns {Boolean}
  //  */
  // export function validEmail (email) {
  //   const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //   return reg.test(email)
  // }
  
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  export function isString (str) {
    if (typeof str === 'string' || str instanceof String) {
      return true
    }
    return false
  }
  
  /**
   * @param {Array} arg
   * @returns {Boolean}
   */
  export function isArray (arg) {
    if (typeof Array.isArray === 'undefined') {
      return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
  }
  
  // 验证是否数字
  export function isNumber (rule, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback()
    }
    if (!Number(value) && value !== 0 && value !== '0') {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  }
  
  // 验证是否正数
  export function isPositiveNumber (rule, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback()
    }
    if (!Number(value) || Number(value) <= 0) {
      callback(new Error('请输入正数'))
    } else {
      callback()
    }
  }
  
  // 验证是否正整数
  export function isInteger (rule, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback()
    }
    if (!Number(value)) {
      callback(new Error('请输入正整数'))
    } else {
      const re = /^[0-9]*[1-9][0-9]*$/
      const rsCheck = re.test(value)
      if (!rsCheck) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }
  }
  
  // 验证IP
  export function validateIP (rule, value, callback) {
    if (value && value === '...') {
      callback(new Error('请输入IP地址'))
    } if (value && !(/((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/).test(value)) {
      callback(new Error('IP地址不规范'))
    } else {
      callback()
    }
  }
  
  /* 是否手机号码 */
  export function validatePhone (rule, value, callback) {
    const reg = /^[1][3,4,5,7,8][0-9]{9}$/
    if (value === '' || value === undefined || value == null) {
      callback()
    } else {
      if ((!reg.test(value)) && value !== '') {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
  }
  
  /* 是否固定电话 */
  export function validateTelephone (rule, value, callback) {
    const reg = /^\d{3,4}-?\d{7,9}$/
    if (value === '' || value === undefined || value == null) {
      callback()
    } else {
      if ((!reg.test(value)) && value !== '') {
        callback(new Error('请输入正确的固定电话'))
      } else {
        callback()
      }
    }
  }
  
  /* 验证密码 密码长度为6 - 18个字符 */
  export function validatePassword (rule, value, callback) {
    if (value === '' || value === undefined || value === null) {
      callback()
    } else if (value.toString().length < 6 || value.toString().length > 18) {
      callback(new Error('密码长度为6 - 18个字符'))
    } else {
      callback()
    }
  }
  
  export function validateEmail (rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入邮箱'))
    } else {
      if (value !== '') {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        }
      }
      callback()
    }
  };
  


// WEBPACK FOOTER //
// ./src/utils/validate.js